import { GridRenderCellParams, GridTreeNodeWithRender } from '@mui/x-data-grid-pro'
import { GridCommentCell } from 'components/shared'
import { FC } from 'react'
import { DensityStyleTypes } from 'types'

interface CommentCellProps {
  params: GridRenderCellParams<any, any, any, GridTreeNodeWithRender>
  densityStyles: DensityStyleTypes
  route?: string
}

const NcoCommentCell: FC<CommentCellProps> = ({ params, densityStyles, route }) => {
  return (
    <GridCommentCell
      params={params}
      densityStyles={densityStyles}
      boardTheme="icon.nco"
      route={route}
      routeConfig={{ basePath: '/nco', childQueryParam: 'task' }}
      parentOnly
      hidePinnedRows
      countField="ncoCommentCount"
    />
  )
}

export default NcoCommentCell
